/**
 * Endpoints Config Shim
 * This file provides backwards compatibility for services that reference the old endpoints config
 * For the new admin authentication system, use adminEndpointManager.js instead
 */

import { getAdminEndpoint } from '../services/endpoints/adminEndpointManager';

// Legacy exports for backwards compatibility

export const getCurrentEnvironment = () => {
  const endpoint = getAdminEndpoint();
  return {
    name: 'Custom Environment',
    description: 'User configured environment',
    authServiceEndpoint: endpoint,
    apiConfig: {
      API_PREFIX: '/admin-api/v1',
      ADMIN_API_KEY: ''
    },
    theme: {
      primaryColor: '#4361EE',
      backgroundColor: '#f8f9fa'
    }
  };
};

export const setCurrentEnvironment = (envName) => {
  console.log('[Endpoints Shim] setCurrentEnvironment called:', envName);
  return false;
};

export const resetEnvironmentToDefault = () => {
  console.log('[Endpoints Shim] resetEnvironmentToDefault called (no-op)');
  return null;
};

export const loadStoredEnvironment = () => {
  console.log('[Endpoints Shim] loadStoredEnvironment called (no-op)');
};

export const addCustomEnvironment = (key, config) => {
  console.log('[Endpoints Shim] addCustomEnvironment called (no-op)');
  return {};
};

export const loadEnvironmentsFromFile = (file) => {
  console.log('[Endpoints Shim] loadEnvironmentsFromFile called (no-op)');
  return Promise.resolve({});
};

export const resetToDefaultEnvironments = () => {
  console.log('[Endpoints Shim] resetToDefaultEnvironments called (no-op)');
  return {};
};

export const getAvailableEnvironments = () => {
  return [];
};

export const getAllEnvironments = () => {
  return {};
};

// Legacy exports
export const getApiServiceEndpoint = () => getCurrentEnvironment()?.authServiceEndpoint || '';
export const getApiConfig = () => getCurrentEnvironment()?.apiConfig || null;

// Default export
export default getCurrentEnvironment;
